var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmiley(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 0.25C3.46875 0.25 0 3.71875 0 8C0 12.2812 3.46875 15.75 7.75 15.75C12.0312 15.75 15.5 12.2812 15.5 8C15.5 3.71875 12.0312 0.25 7.75 0.25ZM7.75 14.25C4.28125 14.25 1.5 11.4688 1.5 8C1.5 4.5625 4.28125 1.75 7.75 1.75C11.1875 1.75 14 4.5625 14 8C14 11.4688 11.1875 14.25 7.75 14.25ZM5.25 7.5C5.78125 7.5 6.25 7.0625 6.25 6.5C6.25 5.96875 5.78125 5.5 5.25 5.5C4.6875 5.5 4.25 5.96875 4.25 6.5C4.25 7.0625 4.6875 7.5 5.25 7.5ZM10.25 7.5C10.7812 7.5 11.25 7.0625 11.25 6.5C11.25 5.96875 10.7812 5.5 10.25 5.5C9.6875 5.5 9.25 5.96875 9.25 6.5C9.25 7.0625 9.6875 7.5 10.25 7.5ZM10.375 9.78125C9.71875 10.5625 8.75 11 7.75 11C6.71875 11 5.75 10.5625 5.125 9.78125C4.84375 9.46875 4.375 9.4375 4.0625 9.6875C3.75 9.9375 3.6875 10.4375 3.96875 10.75C4.90625 11.875 6.28125 12.5 7.75 12.5C9.1875 12.5 10.5625 11.875 11.5 10.75C11.7812 10.4375 11.75 9.9375 11.4062 9.6875C11.0938 9.4375 10.625 9.46875 10.375 9.78125Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmiley);
export default __webpack_public_path__ + "static/media/smiley.d9760bf72c8e461a16544c869850d17d.svg";
export { ForwardRef as ReactComponent };